import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { UserService, BaseDataService, BaseCommonComponent, ModalService, QueryParameter, LoaderService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModelDataService } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { Subject } from 'rxjs';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-pregled-go',
  templateUrl: './pregled-go.component.html'
})
export class PregledGoComponent
  extends BaseCommonComponent
  implements OnInit {
  Config = {}
  mainItems = []

   baseFormGroup:FormGroup=new FormGroup({ })

//   get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;
  podaciSuUcitani: boolean=false;
  // OmogucenaPromenaUslova;
  OmogucenaPromenaUslova = new Subject<boolean>();

  constructor(

    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    public modelDataService: ModelDataService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected loaderService: LoaderService
  ) {

    super(activatedRoute
      , userService
      , baseDataService
      , translateService
      , modalService
      , toastrService
    );
    
  }

  ngOnInit() {
    super.ngOnInit();
    let dateNow = new Date();
    this.baseFormGroup = new FormGroup({
        // OdGodine: new FormControl(null, [Validators.required]),
        // DoGodine: new FormControl(null, [Validators.required])
 
        DatumOd: new FormControl(null, [Validators.required])
      })
  }



  OnModelDataLoaded() {
    super.OnModelDataLoaded();
    this.Config = {
      EditIcon: {
        Visible: this.modelData.MainList.EnableEdit
      },
      DeleteIcon: {
        Visible: this.modelData.MainList.EnableDelete
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100c',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: this.modelData.MainList.EnablePrint
      }
      , BreadCrumble: this.modelData.BreadcrumbLabel
    }
  }


  OnDataLoaded(){
    this.podaciSuUcitani=true;
    // this.baseFormGroup.get("OdGodine").disable();
    // this.baseFormGroup.get("DoGodine").disable();
    
    this.baseFormGroup.get("DatumOd").disable();

    super.OnDataLoaded();
  }

  MenjajUslove() {
    // this.baseFormGroup.get("OdGodine").enable();
    // this.baseFormGroup.get("DoGodine").enable();
    
    this.baseFormGroup.get("DatumOd").enable();
    
    this.podaciSuUcitani=false;
    this.OmogucenaPromenaUslova.next(true);
    
  }

}
